import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-download-image',
  imports: [],
  templateUrl: './download-image.component.html',
  styleUrl: './download-image.component.scss'
})
export class DownloadImageComponent {
  constructor(private http: HttpClient) {}

   ngOnInit(): void {
    // Initialization logic here
    console.log('Component initialized!');
    
  }
}
